import { MenuService } from './../../../services/app.menu.service';
import { ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { InnerPageLayoutComponent } from './inner-page-layout.component';
import { MenuItem } from 'primeng/api';
import { NavigationEnd, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { TranslateService } from '@ngx-translate/core';
import { IpAddressService } from 'src/app/services/ip-address.service';
import { ActivityRecordService } from 'src/app/services/activity-record.service';
import { BaseService } from 'src/app/services/common/base.service';
import { ReportsService } from 'src/app/services/reports.service';
import { first, Subscription } from 'rxjs';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { FarmersDetailsService } from 'src/app/services/farmers-details.service';
import { MessageService } from 'primeng/api';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
@Component({
  selector: 'app-topbar',
  templateUrl: './app.topbar.component.html',
  styleUrls: ['./app.topbar.component.scss'],
})
export class AppTopBarComponent implements OnInit {
  userName: any;
  wrongNotificationCheck: boolean = true;
  selectedLang: any;
  items: MenuItem[];
  date: any;
  ipAddress: any = '000.000.000';
  loginId: any;
  status: any;
  selectYear: any;
  financialYears: any[] = [];
  selectedYear: any;
  public showFinYearBlock: boolean = true;
  isAdharValid: any;
  showAadharVerDialog: boolean = false;
  aadharNumber: any;
  aadharVerOTP: number;
  timer: number = 60;
  intervalId: any;
  isAadharVerified: boolean = false;
  showKYCUpdateLink: boolean = false;


  public farmerData: any;
  public showKYCPopUpDialog = false;
  public consentCheckboxValue: any;

  constructor(
    public router: Router,
    public appMain: InnerPageLayoutComponent,
    public authService: AuthenticationService,
    private translateService: TranslateService,
    private menuService: MenuService,
    private ipService: IpAddressService,
    private activityRecordService: ActivityRecordService,
    private service: BaseService,
    private reportsService: ReportsService,
    private loader: AppLoaderService,
    private farmersDetailsService: FarmersDetailsService,
    private messageService: MessageService,
    private _personalDetalSer: FarmersDetailsService,
    private cryptoJsService: CryptoJsService,
    private cd: ChangeDetectorRef
  ) {
    this.router.events.subscribe((event) => {
      // Update currentUrl whenever the route changes
      if (event instanceof NavigationEnd) {
        if (this.router.url.includes('consolidated-report') || this.router.url.includes('new-registration')) {
          this.showFinYearBlock = false;
        } else {
          this.showFinYearBlock = true;
        }
      }
    });
  }

  ngOnInit() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let isApplyForNocRed = farmerconfData.get('isApplyForNocRed')
    let userId = farmerconfData.get('userID');
    let yearList = farmerconfData.has('yearList');

    if (userId == 'farmer' || userId == 'ownMIfarmer' && isApplyForNocRed == '1' && this.router.url.includes('farmer/dashboard')) {
      // this.loadPersonalDetails();
      this.checkKYCStatus(farmerconfData);
    }

    if (sessionStorage.getItem('yearList')) {
      this.financialYears = JSON.parse(sessionStorage.getItem('yearList'));

      this.service.changeFinancialYear(sessionStorage.getItem('financialYear'));
      let year = sessionStorage.getItem('financialYear');
      this.selectedYear = { name: year, code: year };
    } else {
      this.reportsService
        .getFinanacialYearList()
        .pipe(first())
        .subscribe({
          next: (data) => {

            data.forEach((e: any) => {
              let year = { name: e.FinancialYears, code: e.FinancialYears };
              this.financialYears.push(year);
            });
            this.selectedYear = { ...this.financialYears[1] };

            
            const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
            const farmerconfData = new Map(encData);

            farmerconfData.set('yearList', JSON.stringify(this.financialYears));

            const dataF = JSON.stringify(Array.from(farmerconfData.entries()));
            sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));
            
            
            sessionStorage.setItem(
              'yearList',
              JSON.stringify(this.financialYears)
            );
            
            this.service.changeFinancialYear(this.selectedYear.code);
            this.ngOnDestroy();
          },
        });
    }
    if (localStorage.getItem('lang')) {
      this.selectedLang = localStorage.getItem('lang')
        ? JSON.parse(localStorage.getItem('lang'))
        : '';
      this.translateService.use(this.selectedLang.code);
    }
    this.getLoginId();
    if (!this.userName) {
      this.userName = sessionStorage.getItem('newUserName');
    }

    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
 
    const loginUserName = loginDetails.get('loginUserName') ? loginDetails.get('loginUserName') : null;

    let farmerName = loginUserName;
    if (farmerName) {
      this.userName = farmerName;
    }
    this.items = [
      {
        label: 'Logout',
        icon: 'pi pi-fw pi-sign-in',
        command: () => {
          this.logOut();
          //  const [ngClass]="{'position': sticky}";
        },
      },
    ];
    this.menuService.userName$.subscribe((data) => {

      sessionStorage.setItem('newUserName', data);
      this.userName = data;
    });
  }

  // ngAfterViewChecked() {
  //   this.cd.detectChanges();
  // }
  
  ngOnDestroy() {
    // Clear the interval when the component is destroyed
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  loadPersonalDetails() {
    this.loader.start();
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let phNo = farmerconfData.get('farmerPh') ? farmerconfData.get('farmerPh') : '';
    
    let reqBody = {
      MobileNo : phNo
    }

    let reqBodyAfterEncypt = {
      "payload": this.cryptoJsService.EncryptPayload(JSON.stringify(reqBody))
    }

    let sub = this._personalDetalSer
      .getFarmerDetails(reqBodyAfterEncypt)
      .pipe(first())
      .subscribe({
        next: (resp) => {
          this.loader.close();
          let data = JSON.parse(this.cryptoJsService.DecryptToken(resp.data));

          if (data) {
            this.activityRecordService.activityRecord(
              phNo,
              'Personal Details For KYC',
              '',
              new Date(),
              'Success'
            );
            let farmerData = data[0];
            if (farmerData) {
              this.showKYCUpdateLink = true;
              this.farmerData = farmerData;

              this.showKYCPopUpDialog = true;

              const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
              const farmerconfData = new Map(encData);

              farmerconfData.set('farmerDetails', data[0]);

              const dataF = JSON.stringify(Array.from(farmerconfData.entries()));
              sessionStorage.setItem('dataF', this.cryptoJsService.EncryptSession(dataF));
            }
          }else{
            this.showKYCUpdateLink = true;
            this.showKYCPopUpDialog = true;
            this.farmerData = null;
          }
        },
        error: (err) => {
          this.loader.close();
          if(err.message == "Not Registered"){
            this.showKYCUpdateLink = true;
            this.showKYCPopUpDialog = true;
            this.farmerData = null;
          }else {
            this.showKYCPopUpDialog = false;
          }
        },
      });

    // this.subscriptions.push(sub);
  }

  checkKYCStatus(farmerconfData) {
    this.showKYCUpdateLink = true;
    // this.farmerData = farmerData;
    this.farmerData = {
      "AadharStatus": farmerconfData.get('AadharStatus_'),
      "Farmer_ID": farmerconfData.get('Farmer_Id_'),
    }
    // this.farmerData = {
    //   "AadharStatus": true,
    //   "Farmer_ID": 'FA202200000006412N',
    // }
    this.showKYCPopUpDialog = true;
  }

  openKYCPopUp(){
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    
    this.farmerData = {
      "AadharStatus": farmerconfData.get('AadharStatus_'),
      "Farmer_ID": farmerconfData.get('Farmer_Id_'),
    }

    this.showKYCPopUpDialog = true;
  }

  getLoginId() {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let isFarmerLogin = farmerconfData.get('isFarmerLogin');

    if (isFarmerLogin == '1') {
      this.loginId = farmerconfData.get('farmerPh');
    } else {
      let sessionToken = null;
      if(sessionStorage.getItem('token')){
        sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
      }
      if(sessionToken == null){
        this.logOut();
      }

      let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
      this.loginId = JSON.parse(payload)?.sub;
    }
  }

  logOut() {
    this.activityRecordService.activityRecord(
      this.loginId,
      'logout',
      '',
      new Date(),
      'Success'
    );
    
    sessionStorage.clear();
    setTimeout(() => { this.router.navigate(['/home']) }, 100);
  }

  languageChange(event) {
    localStorage.setItem('lang', JSON.stringify(event.value));
    this.translateService.use(event.value.code);
  }

  yearChange(event) {
    // localStorage.setItem('Financial_year', JSON.stringify(event.value));
    // this.translateService.use(event.value.code)

    
    this.service.changeFinancialYear(event.value.code);
  }

  // verifyAadhar() {
  //   // this.aadharNumber = this.farmersDetailsForm.value['aadharNo'];
  //   this.validateAadharNumber(this.aadharNumber);
  //   this.showAadharVerDialog = true;
  //   // this.startTimer();
  // }

  // validateAadharNumber(aadharNumber) {
  //   const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));

  //   let phNo = encData.get('farmerPh');
  //   this.loader.start();
  //   this.farmersDetailsService
  //     .validateAadhar(aadharNumber)
  //     .pipe(first())
  //     .subscribe({
  //       next: (data) => {
  //         this.loader.close();

  //         // this.loader.close();
  //         // this.showAadharVerDialog = true;
  //         // this.startTimer();
  //         if (data == 'OTP sent') {
  //           this.showAadharVerDialog = true;
  //           this.startTimer();

  //           this.messageService.add({
  //             severity: 'success',
  //             summary: 'Success Message',
  //             detail: 'OTP Sent Successfully.',
  //           });
  //         } else {
  //           this.showAadharVerDialog = false;
  //           this.messageService.add({
  //             severity: 'info',
  //             summary: 'Info Message',
  //             detail: data,
  //           });
  //         }

  //         this.activityRecordService.activityRecord(
  //           phNo,
  //           'Validate Aadhar Number',
  //           '',
  //           new Date(),
  //           data,
  //           aadharNumber
  //         );
  //       },
  //       error: (err) => {

  //         this.showAadharVerDialog = false;
  //         this.loader.close();
  //         this.messageService.add({
  //           severity: 'error',
  //           summary: 'Error Message',
  //           detail: err,
  //         });

  //         this.activityRecordService.activityRecord(
  //           phNo,
  //           'Validate Aadhar Number(error)',
  //           '',
  //           new Date(),
  //           err,
  //           aadharNumber
  //         );
  //       },
  //     });
  //   // this.startTimer();
  // }

  hideDialog() {
    this.showAadharVerDialog = false;
    this.aadharVerOTP = null;
  }

  submitOTP() {
    this.validateOTP(this.aadharNumber, this.aadharVerOTP);
  }

  validateOTP(aadharNumber, otp) {
    const encData = JSON.parse(this.cryptoJsService.DecryptSession(sessionStorage.getItem('dataF')));
    const farmerconfData = new Map(encData);
    let phNo = farmerconfData.get('farmerPh') ? farmerconfData.get('farmerPh') : '';

    this.loader.start();
    this.farmersDetailsService
      .validateOTP(aadharNumber, otp, '')
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();

          if (data.startsWith('s') || data.startsWith('S')) {
            this.isAadharVerified = true;
            this.hideDialog();
            this.messageService.add({
              severity: 'success',
              summary: 'Success Message',
              detail: 'Aadhar Validated Successfully.',
            });
          } else {
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data,
            });
          }

          this.activityRecordService.activityRecord(
            phNo,
            'Validate OTP For Aadhar Verification',
            '',
            new Date(),
            data,
            aadharNumber
          );
        },
        error: (err) => {
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });

          this.activityRecordService.activityRecord(
            phNo,
            'Validate OTP For Aadhar Verification',
            '',
            new Date(),
            err,
            aadharNumber
          );
        },
      });
  }

  // startTimer() {
  //   this.intervalId = setInterval(() => {
  //     if (this.timer > 0) {

  //       this.timer--;
  //     } else {
  //       clearInterval(this.intervalId);
  //     }
  //   }, 1000);
  // }
  startTimer() {
    this.intervalId = startCountdown(this.timer, (currentValue: number) => {
      this.timer = currentValue;
    });
  }

  resendOTP(): void {
    // Reset timer
    this.timer = 60;
    // Start timer again
    this.startTimer();
  }

  editAadharNumber() {
    this.hideDialog();
  }

  hideKYCDialog(){

  }

  onSubmitConsent(){

  }

  addItem(val){

    this.showKYCPopUpDialog = false;
  }
}


function startCountdown(
  initialValue: number,
  callback: (currentValue: number) => void
) {
  let currentValue = initialValue;

  const intervalId = setInterval(() => {
    if (currentValue > 0) {
      currentValue--;
      callback(currentValue);
    } else {
      clearInterval(intervalId);
    }
  }, 1000);

  return intervalId;
}
